import OrderDelivery from '~cp/UserPanel/Pages/Orders/OrderDelivery'
export const startFulfillment = {
    components: {
        OrderDelivery
    },
    data() {
        return {
            idForDelivery: '',
            preferableDelivery: '',
            minInsurancePrice: null,
            orderAddress: null,
            showLockers: null
        }
    },
    computed: {
        orders() {
            return this.setItems()
        }
    },
    methods: {
        getItemsError(order) {
            if (order.orderedProducts && order.orderedProducts.length === 0) {
                return true
            } else {
                let statusError = order.status.some(item => item !== 'active')
                let availableError = false
                order.productQuantity.forEach((item, index) => {
                    if (item > order.available[index]) {
                        availableError = true
                        return false
                    }
                })
                return statusError || availableError
            }
        },
        getOrderDelivery(payload) {
            this.idForDelivery = payload
            let orderForDelivery = this.orders.find(el => el.id === payload)
            this.preferableDelivery = orderForDelivery.customerPreferableDelivery
            this.orderAddress = {
                zip: orderForDelivery.address.postalCode,
                address: orderForDelivery.address.line1,
                cityName: orderForDelivery.address.city,
                countryId: orderForDelivery.address.country.id
            }
            this.minInsurancePrice = orderForDelivery.owner && orderForDelivery.owner.minInsurancePrice ? +orderForDelivery.owner.minInsurancePrice.toFixed(2) : 0
            this.showLockers = orderForDelivery.owner ? orderForDelivery.owner.fulfillmentSettings.lockerEnabled : false
            this.$root.$emit('bv::show::modal', 'delivery-requests')
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/startFulfillment.js